import * as React from 'react';
import { FC } from 'react';
import IngredientValue from './IngredientValue';

interface SingleIngredientModel {
    ingredient: {
        amount: number,
        id: string,
        ingredientId: string,
        middleText: string,
        name: string,
        postText: string,
        preText: string,
        unit: string,
        unitPluralName: string,
        displayName: string,
        ingredientLink: string,      
    },
    portions: number,
    defaultPortions: number,
}

const SingleIngredient: FC<SingleIngredientModel> = (props) => {
    return (
        <>
            {props.ingredient.preText !== '' && (
                <span>
                    {props.ingredient.preText}&#32;
                &#32;</span>
            )}
           
            {props.ingredient.amount > 0 && (
                <IngredientValue amount={props.ingredient.amount} unit={props.ingredient.unit} unitPluralName={props.ingredient.unitPluralName} portions={props.portions} defaultPortions={props.defaultPortions} />
            )}

            {props.ingredient.middleText !== '' && (
                <span>
                    {props.ingredient.middleText}&#32;
                </span>                
            )}

            {props.ingredient.displayName !== 'seperator' && (
                props.ingredient.ingredientLink !== null ? (
                    <>
                        <a href={props.ingredient.ingredientLink} title={props.ingredient.displayName} className="font-semibold underline decoration-black-text decoration-1 hover:decoration-red-secondary hover:decoration-2 underline-offset-2 focus:outline-red-secondary focus:outline-2 focus:outline-offset-2">
                            {props.ingredient.displayName}
                        </a>&#32;
                    </>
                ) : (
                    <span>{props.ingredient.displayName}&#32;</span>
                )
            )}

            {props.ingredient.postText !== '' && (
                <span>
                    {props.ingredient.postText}&#32;
                </span>                
            )}
        </>
    );
};
export default SingleIngredient;